import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

export function ConfirmDialog({
  open,
  title,
  action,
  content,
  onClose,
  customSubmitButtons,
  ...other
}) {
  const { t } = useLocale(); // ✅ moved inside the function and after params

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2' }}>{content}</DialogContent>}

      <DialogActions>
        {action}
        {!customSubmitButtons && (
          <Button variant="outlined" color="inherit" onClick={onClose}>
            {t('Cancel')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
